import {
  RiArrowDownSLine,
  RiArrowLeftSLine,
  RiArrowRightSLine,
  RiArrowUpSLine,
  RiBookOpenLine,
  RiBookReadLine,
  RiBookShelfLine,
  RiBookmarkLine,
  RiBold,
  RiCheckLine,
  RiCompass3Line,
  RiEdit2Line,
  RiEyeLine,
  RiEyeOffLine,
  RiFileCopyLine,
  RiFolderLine,
  RiGridLine,
  RiHeartLine,
  RiHome5Line,
  RiImageLine,
  RiItalic,
  RiLightbulbLine,
  RiListOrdered,
  RiListUnordered,
  RiMailLine,
  RiMenuLine,
  RiMoreLine,
  RiNotificationLine,
  RiPaletteLine,
  RiPencilLine,
  RiQuillPenLine,
  RiSearchLine,
  RiShareForwardLine,
  RiStarLine,
  RiDeleteBinLine,
  RiTrophyLine,
  RiTranslate2,
  RiUploadCloud2Line,
  RiUserAddLine,
  RiUserLine,
  type RemixiconComponentType
} from "@remixicon/react";

export const iconRegistry = {
  account: RiUserLine,
  back: RiArrowLeftSLine,
  bell: RiNotificationLine,
  bookmark: RiBookmarkLine,
  bookshelf: RiBookShelfLine,
  brand: RiQuillPenLine,
  chapters: RiListOrdered,
  check: RiCheckLine,
  chevron: RiArrowDownSLine,
  collection: RiBookShelfLine,
  contest: RiTrophyLine,
  copy: RiFileCopyLine,
  create: RiEdit2Line,
  discover: RiCompass3Line,
  document: RiBookReadLine,
  editorBold: RiBold,
  editorBulletList: RiListUnordered,
  editorItalic: RiItalic,
  editorOrderedList: RiListOrdered,
  favorite: RiHeartLine,
  follow: RiUserAddLine,
  grid: RiGridLine,
  guide: RiPencilLine,
  home: RiHome5Line,
  idea: RiLightbulbLine,
  illustration: RiImageLine,
  latest: RiStarLine,
  mail: RiMailLine,
  manga: RiBookOpenLine,
  menu: RiMenuLine,
  more: RiMoreLine,
  novel: RiBookReadLine,
  palette: RiPaletteLine,
  passwordHide: RiEyeOffLine,
  passwordShow: RiEyeLine,
  project: RiFolderLine,
  ranking: RiStarLine,
  remove: RiDeleteBinLine,
  request: RiHeartLine,
  right: RiArrowRightSLine,
  search: RiSearchLine,
  share: RiShareForwardLine,
  translation: RiTranslate2,
  upload: RiUploadCloud2Line,
  up: RiArrowUpSLine
} satisfies Record<string, RemixiconComponentType>;

export type IconName = keyof typeof iconRegistry;

export function Icon({
  name,
  className = "",
  label,
  size = 20
}: {
  name: IconName;
  className?: string;
  label?: string;
  size?: number | string;
}) {
  const IconComponent = iconRegistry[name];
  return label ? (
    <IconComponent
      aria-label={label}
      className={`remixicon ${className}`.trim()}
      role="img"
      size={size}
    />
  ) : (
    <IconComponent
      aria-hidden="true"
      className={`remixicon ${className}`.trim()}
      size={size}
    />
  );
}
